import { useState, useEffect, useRef } from "react";
import useOnlineStatus from "../../hooks/useOnlineStatus";

const OfflineBanner = () => {
  const isOnline = useOnlineStatus();
  const [showReconnected, setShowReconnected] = useState(false);
  const prevOnline = useRef(null);

  useEffect(() => {
    // Only fire the "back online" flash after being previously offline
    if (prevOnline.current === false && isOnline) {
      setShowReconnected(true);
      const t = setTimeout(() => setShowReconnected(false), 3000);
      return () => clearTimeout(t);
    }
    prevOnline.current = isOnline;
  }, [isOnline]);

  if (isOnline && !showReconnected) return null;

  const styles = {
    position: "fixed",
    bottom: "64px", // sits above the mobile bottom nav
    left: 0,
    right: 0,
    zIndex: 2000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    padding: "0.6rem 1rem",
    fontSize: "0.85rem",
    fontWeight: 500,
    textAlign: "center",
    boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
  };

  if (showReconnected) {
    return (
      <div style={{ ...styles, background: "#2E7D32", color: "#fff" }}>
        <span>✓</span>
        <span>Back online — all changes synced</span>
      </div>
    );
  }

  return (
    <div style={{ ...styles, background: "#37474F", color: "#fff" }}>
      <span>📡</span>
      <span>You're offline — entries will save automatically when you reconnect</span>
    </div>
  );
};

export default OfflineBanner;
